import {
  getLocalStorageValue,
  IS_PRERENDER,
  LOCAL_STORAGE_KEYS
} from '@namespace/helpers';
import logGaAction from '../logGaAction';
import { logNewRelicAction } from '../logNewRelicAction';
import { ActionAttributes } from '../types';

export const logAction = (
  actionName: string,
  attributes?: ActionAttributes
): void => {
  if (!IS_PRERENDER) {
    const affiliateInSessionStorage = getLocalStorageValue(
      LOCAL_STORAGE_KEYS.AFFILIATE_COOKIES,
      null
    );

    const enhancedAttributes = {
      ...attributes,
      ...(affiliateInSessionStorage
        ? { affiliate: affiliateInSessionStorage }
        : {}),
      userId: attributes?.userId || window.g_user_id
    };

    logGaAction(actionName, enhancedAttributes);
    logNewRelicAction(actionName, enhancedAttributes);
  }
};
